module.exports = __webpack_public_path__ + "img/Home12.b81533d2.jpg";